import type React from 'react';

import { SearchIcon } from '@vlabs/icons';
import { routes } from '@vlabs/shared/navigation/routes';
import { Button } from '@vlabs/uikit/components/controls/button/Button';
import type { WithDataTestid } from '@vlabs/uikit/types';
import qs from 'qs';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

interface SearchSimilarFacesButtonPoint3Props extends WithDataTestid {
  faceId: string;
  variant?: 'filled' | 'flat' | 'outlined' | 'dimmed' | 'flat-inverted';
  size?: 'medium' | 'small';
}

export function SearchSimilarFacesButtonPoint3({
  faceId,
  variant = 'flat',
  size = 'small',
  'data-testid': dataTestId = 'searchSimilarFacesButton',
}: SearchSimilarFacesButtonPoint3Props): React.JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();

  const buttonTitle = t('monokit:search similar faces.button');
  const searchPath = `${routes.search}?${qs.stringify({
    references: [{
      id: faceId,
      type: 'face',
      referenceType: 'face',
      candidateOrigin: 'faces',
    }],
  })}`;

  return (
    <Button
      data-testid={dataTestId}
      disabled
      icon={<SearchIcon />}
      onClick={() => history.push(searchPath)}
      size={size}
      title={buttonTitle}
      variant={variant}
    >
      {buttonTitle}
    </Button>
  );
}
